import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
import _defineProperty from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
const _excluded = ["children"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useContext } from 'react';
import { Box } from '@hub/box';
import { CoreContainer } from '@hub/core-container';
import { Text } from '@hub/text';
import { Portal } from '@hub/portal';
import { LinkContext } from '../../../context';
import { transformNavigationClickedItemsData } from '../../../analytics-segment/events/navigation-item';
import { MegaMenuFeaturedItem } from './megamenu-featured-item';
import { MainNavItemWrapper } from './main-nav-item-wrapper';
import { useAnalytics } from '../../../analytics';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const isLinkItem = megamenuItem => 'label' in megamenuItem && 'url' in megamenuItem;
const getKey = megaMenuItem => {
  if (isLinkItem(megaMenuItem)) {
    return "".concat(megaMenuItem.url, "-").concat(megaMenuItem.label);
  } else {
    const keyParts = ['feature'];
    const {
      title,
      body,
      link
    } = megaMenuItem;
    if (title) {
      keyParts.push(title);
    }
    if (body) {
      keyParts.push(body);
    }
    if (link) {
      keyParts.push(getKey(link));
    }
    return keyParts.join('-');
  }
};
const MegaMenuItem = _ref => {
  let {
    megaMenuItem,
    index,
    itemLabel,
    featuredItemRef
  } = _ref;
  const Link = useContext(LinkContext);
  const analytics = useAnalytics();
  if (!isLinkItem(megaMenuItem)) {
    return /*#__PURE__*/_jsx(Portal, {
      containerRef: featuredItemRef,
      "data-id": "tabs_megamenu_MegaMenuItem_Portal",
      children: /*#__PURE__*/_jsx(MegaMenuFeaturedItem, {
        parentCategory: itemLabel,
        feature: megaMenuItem,
        "data-id": "tabs_megamenu_MegaMenuItem_Portal_MegaMenuFeaturedItem"
      })
    });
  }
  const LinkWithUrl = props => /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
    to: megaMenuItem.url,
    "data-id": "tabs_megamenu_MegaMenuItem_Link"
  }));
  return /*#__PURE__*/_jsxs(MainNavItemWrapper, {
    sx: {
      paddingTop: 'spacing-xs',
      height: megaMenuItem.fullColumn ? '100%' : 'revert',
      width: '25%',
      a: {
        paddingBottom: 'spacing-1',
        height: 'spacing-md',
        display: 'block',
        _hover: {
          textDecoration: 'underline'
        }
      },
      'ul li a': {
        paddingBottom: 'initial',
        height: 28
      }
    },
    "data-id": "tabs_megamenu_MegaMenuItem_MainNavItemWrapper",
    children: [/*#__PURE__*/_jsx(Text, {
      tone: "strong",
      onClick: () => {
        transformNavigationClickedItemsData(analytics, {
          parentLabel: itemLabel,
          itemLabel: megaMenuItem.label,
          link: megaMenuItem.url
        });
      },
      as: LinkWithUrl,
      id: "megamenu-item-".concat(index),
      lineHeight: "none",
      "data-id": "tabs_megamenu_MegaMenuItem_MainNavItemWrapper_Text",
      children: megaMenuItem.label
    }), megaMenuItem.megaMenuItems && /*#__PURE__*/_jsx(Box, {
      as: "ul",
      "data-id": "tabs_megamenu_MegaMenuItem_Box",
      children: megaMenuItem.megaMenuItems.map(subItem => /*#__PURE__*/_jsx(_Fragment, {
        children: isLinkItem(subItem) && /*#__PURE__*/_jsx(MainNavItemWrapper, {
          "data-id": "tabs_megamenu_MegaMenuItem_MainNavItemWrapper",
          children: /*#__PURE__*/_jsx(Link, {
            to: subItem.url,
            component: _ref2 => {
              let {
                  children
                } = _ref2,
                props = _objectWithoutProperties(_ref2, _excluded);
              return /*#__PURE__*/_jsx("a", _objectSpread(_objectSpread({}, props), {}, {
                "data-id": "tabs_megamenu_MegaMenuItem_a",
                children: children
              }));
            },
            onClick: () => {
              transformNavigationClickedItemsData(analytics, {
                parentLabel: itemLabel,
                subParentLabel: megaMenuItem.label,
                itemLabel: subItem.label,
                link: subItem.url
              });
            },
            "data-id": "tabs_megamenu_MegaMenuItem_MainNavItemWrapper_Link",
            children: subItem.label
          }, getKey(subItem))
        }, getKey(subItem))
      }))
    })]
  });
};
export const MegaMenu = _ref3 => {
  let {
    itemId,
    itemLabel,
    megaMenuItems
  } = _ref3;
  const featuredItemRef = React.useRef(null);
  return /*#__PURE__*/_jsxs(CoreContainer, {
    id: itemId,
    sx: {
      fontSize: 'font-sm',
      paddingY: 'spacing-md',
      display: 'flex',
      maxHeight: '544px',
      justifyContent: 'space-between'
    },
    "data-id": "tabs_megamenu_MegaMenuItem_CoreContainer",
    children: [/*#__PURE__*/_jsx(Box, {
      as: "ul",
      id: itemId,
      sx: {
        display: 'flex',
        flexDirection: 'column',
        flexWrap: 'wrap',
        alignContent: 'flex-start',
        flexBasis: '100%',
        overflow: 'hidden'
      },
      "data-id": "tabs_megamenu_MegaMenuItem_CoreContainer_Box",
      children: megaMenuItems && megaMenuItems.map((megaMenuItem, i) => /*#__PURE__*/_jsx(MegaMenuItem, {
        megaMenuItem: megaMenuItem,
        index: i,
        itemLabel: itemLabel,
        featuredItemRef: featuredItemRef,
        "data-id": "tabs_megamenu_MegaMenuItem"
      }, getKey(megaMenuItem)))
    }), /*#__PURE__*/_jsx(Box, {
      ref: featuredItemRef,
      sx: {
        maxWidth: [0, 0, 0, '25%'],
        flexBasis: [0, 0, 0, '25%']
      },
      "data-id": "tabs_megamenu_MegaMenuItem_CoreContainer_Box"
    })]
  });
};